














import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MenuItem } from '@/types/apiServerContract';
import AnimateValue from '@/core/ui-components/AnimateValue.vue';
import localeNumberFilter from '@/project/filters/localeNumber.filter';

@Component({
    components: { AnimateValue }
})
export default class CategoryNameAndCount extends Vue {
    @Prop({
        type: Object,
        default: 'string'
    })
    private menuItem!: MenuItem;

    @Prop({
        type: Boolean,
        default: false
    })
    private hideProductCount!: boolean;

    private get value() {
        return `(${localeNumberFilter(this.menuItem.productCount)})`;
    }

    private get showValue() {
        return !this.hideProductCount && typeof this.menuItem.productCount === 'number';
    }
}
